import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    prevUrl: String, 
    nextUrl: String 
  }

  connect() {
    console.log("Navigation controller connected", {
      prevUrl: this.prevUrlValue,
      nextUrl: this.nextUrlValue
    })
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    if (this.boundHandleKeydown) {
      document.removeEventListener("keydown", this.boundHandleKeydown)
    }
  }

  handleKeydown(event) {
    // Only handle if no input/textarea is focused and no modifiers are pressed
    if (event.target.tagName === "INPUT" || 
        event.target.tagName === "TEXTAREA" || 
        event.target.contentEditable === "true" ||
        event.ctrlKey || 
        event.metaKey || 
        event.shiftKey || 
        event.altKey) {
      return
    }

    console.log("Key pressed:", event.key)
    switch(event.key) {
      case "ArrowLeft":
        console.log("Left arrow - navigating to prev:", this.prevUrlValue)
        event.preventDefault()
        this.navigatePrev()
        break
      case "ArrowRight":
        console.log("Right arrow - navigating to next:", this.nextUrlValue)
        event.preventDefault()
        this.navigateNext()
        break
    }
  }

  navigatePrev() {
    if (this.prevUrlValue) {
      window.location.href = this.prevUrlValue
    }
  }

  navigateNext() {
    if (this.nextUrlValue) {
      window.location.href = this.nextUrlValue
    }
  }
}